<template>
	<div class="adsearchs">
		<el-form v-model="searchParams">
			<div class="adsearchkey">
				<div class="inputsearch">
					<input v-model.trim="searchParams.queryInfo" clearable @clear="handleSearch" class="keyinput" name="adkeys" placeholder="输入标准编号、名称或关键词..." type="text" />
				</div>
				<el-button icon="el-icon-search" round type="primary" @click="handleSearch"> 检索</el-button>
				<div class="searchbtn pointer" style="display: none" @click="handleSearch"><img alt="" src="@/assets/images/searchbanner/search.png" style="width: 21px; margin-right: 10px" /> 检索</div>
			</div>
			<div class="adsearchcon">
				<div class="flexStart">
					<el-row :gutter="30">
						<el-col :span="6">
							<div class="form-group">
								<label class="form-label">发布单位</label>
								<input v-model.trim="searchParams.issueAgency" class="form-input" placeholder="请输入发布单位" type="text" />
							</div>
						</el-col>
						<el-col :span="6">
							<div class="form-group">
								<label class="form-label">归口单位</label>
								<input v-model.trim="searchParams.underAgency" class="form-input" placeholder="请输入归口单位" type="text" />
							</div>
						</el-col>
						<el-col :span="6">
							<div class="form-group">
								<label class="form-label">发布日期</label>
								<el-date-picker v-model="releaseDate" end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" style="width: 100%" type="daterange" value-format="yyyy-MM-dd">
								</el-date-picker>
							</div>
						</el-col>
						<el-col :span="6">
							<div class="form-group">
								<label class="form-label">实施日期</label>
								<el-date-picker v-model="executeDate" end-placeholder="结束日期" range-separator="至" start-placeholder="开始日期" style="width: 100%" type="daterange" value-format="yyyy-MM-dd">
								</el-date-picker>
							</div>
						</el-col>
					</el-row>
				</div>
				<div class="topicgroup">
					<div class="title">生命周期</div>
					<el-checkbox-group v-model="lifes" class="topcheck">
						<el-checkbox v-for="item in lifeLabelList" :key="item.labelId" :label="item.labelId">{{ item.labelName }}</el-checkbox>
					</el-checkbox-group>
					<div class="title">专业领域</div>
					<el-checkbox-group v-model="majors" class="topcheck">
						<el-checkbox v-for="item in majorLabelList" :key="item.labelId" :label="item.labelId">{{ item.labelName }}</el-checkbox>
					</el-checkbox-group>
					<div class="title">种类</div>
					<el-checkbox-group v-model="searchParams.categoryId" class="topcheck">
						<el-checkbox v-for="item in categoryLabelList" :key="item.categoryId" :label="item.categoryId">{{ item.categoryName }}</el-checkbox>
					</el-checkbox-group>
				</div>
			</div>
		</el-form>
	</div>
</template>

<script>
	import { getLifeStandardLabel, getMajorStandardLabel, getStandardCategory } from '@/api/standards/search';
	import moment from 'moment';

	export default {
		inject: ['updateAdgrandData'], // 注入祖父组件提供的方法
		data() {
			return {
				checkAll: false,

				releaseDate: null,
				executeDate: null,

				lifes: [],
				majors: [],

				searchParams: {
					categoryId: [],
					queryInfo: '',
					issueAgency: '',
					underAgency: '',
					issueBegin: '',
					issueEnd: '',
					effectiveBegin: '',
					effectiveEnd: ''
				},

				lifeLabelList: [],
				majorLabelList: [],
				categoryLabelList: []
			};
		},
		components: {},
		created() {
			this.getLifeStandardLabel();
			this.getMajorStandardLabel();
			this.getStandardCategory();
		},
		methods: {
			//获取标签(生命周期)
			async getLifeStandardLabel() {
				let res = await getLifeStandardLabel();
				if (res.code == 200) {
					this.lifeLabelList = res.data;
				}
			},

			//获取标签(专业领域)
			async getMajorStandardLabel() {
				let res = await getMajorStandardLabel();
				if (res.code == 200) {
					this.majorLabelList = res.data;
				}
			},

			//获取种类(特种设备)
			async getStandardCategory() {
				let res = await getStandardCategory();
				if (res.code == 200) {
					this.categoryLabelList = res.data;
				}
			},

			handleSearch() {
				if (this.releaseDate == null) {
					this.searchParams.issueBegin = '';
					this.searchParams.issueEnd = '';
				} else {
					if (this.releaseDate[0]) {
						this.searchParams.issueBegin = moment(this.releaseDate[0]).format('YYYY-MM-DD');
					}
					if (this.releaseDate[1]) {
						this.searchParams.issueEnd = moment(this.releaseDate[1]).format('YYYY-MM-DD');
					}
				}
				if (this.executeDate == null) {
					this.searchParams.effectiveBegin = '';
					this.searchParams.effectiveEnd = '';
				} else {
					if (this.executeDate[0]) {
						this.searchParams.effectiveBegin = moment(this.executeDate[0]).format('YYYY-MM-DD');
					}
					if (this.executeDate[1]) {
						this.searchParams.effectiveEnd = moment(this.executeDate[1]).format('YYYY-MM-DD');
					}
				}
				this.searchParams.labelId = this.lifes.concat(this.majors);

				let params = { ...this.searchParams };

				this.updateAdgrandData(params);
				return;

				// 将多个参数封装为对象
				// const params = {
				// 	// queryInfo: this.queryInfo,
				// 	issueAgency: this.adsearchform.issueAgency,
				// 	releaseDate: this.adsearchform.releaseDate,
				// 	underAgency: this.adsearchform.underAgency,
				// 	executeDate: this.adsearchform.executeDate
				// };
			}
		}
	};
</script>

<style lang="less" scoped>
	@border: 1px solid #cee2f9;
	@boxshadow: 0px 0px 5px 0px rgba(20, 116, 226, 0.5);
	.adsearchs {
		border-radius: 7px 7px 7px 7px;
		background-color: #ffffff;
		.adsearchkey {
			// width: 80%;
			border-radius: 7px 7px 7px 7px;
			background-color: #ffffff;
			display: flex;
			justify-content: start;
			align-items: center;
			box-shadow: 0px 3px 7px 0px rgba(0, 122, 255, 0.1);
			border-radius: 0px 7px 7px 7px;
			.inputsearch {
				width: 90%;
				height: 50px;
				.keyinput {
					border: 0;
					height: 47px;
					line-height: 47px;
					width: 100%;
				}
			}
		}
		.adsearchcon {
			padding: 20px;
			.form-group {
				//width: 268px;
				//margin: 10px 48px 0 20px;
			}
			/* 标题样式（label 本身是行内元素，设置为块级元素会自动换行） */
			.form-label {
				display: block; /* 关键：让标题成为块级元素，独占一行 */
				margin-bottom: 10px; /* 标题与输入框之间的间距 */
				font-weight: 400; /* 标题加粗 */
				color: #333;
			}
			/* 输入框样式（input 默认是行内块，设置 width: 100% 占满一行） */
			.form-input {
				width: 100%; /* 输入框占满容器宽度 */
				// padding: 8px 12px;
				height: 38px;
				border: @border;
				// box-shadow: @boxshadow;
				border-radius: 5px;
				box-sizing: border-box; /* 确保 padding 不影响总宽度 */
			}
			/deep/ .el-input__inner {
				border: @border;
				// box-shadow: @boxshadow;
				border-radius: 5px;
			}
			.topicgroup {
				padding-bottom: 20px;
				.title {
					margin-top: 18px;
					margin-bottom: 4px;
				}
				/deep/ .el-checkbox__inner {
					border: @border;
					// box-shadow: @boxshadow;
				}
			}
		}
	}
</style>
